<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                Bundle Item Gruppen
              </v-col>
              <v-col class="d-flex justify-end">
                <inertia-link :href="route('bundle.group.create')">
                  <v-btn color="primary">
                    Neu
                  </v-btn>
                </inertia-link>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-data-table :items="groups" :headers="headers">
              <template #[`item.actions`]="{item}">
                <v-icon color="secondary" @click="remove(item)">
                  mdi-delete
                </v-icon>
                <inertia-link :href="route('bundle.group.edit',{group:item.id})">
                  <v-icon color="primary">
                    mdi-pen
                  </v-icon>
                </inertia-link>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'

export default {
   layout: (h, page) => h(Layout, [page]),
   props: {
      groups: {
         required: true,
         type: Array
      }
   },
   data: function () {
      return {
         headers: [
            { text: 'Name', value: 'name' },
            { text: 'Aktionen', value: 'actions' },
         ]
      }
   },
   methods: {
      remove (item) {
         this.$inertia.delete(this.route('bundle.group.destroy', { group: item.id }))
      }
   }

}
</script>

<style lang="scss" scoped>

</style>
